import { atom } from 'jotai/index';
import { IPrimaryComment, IUserDetail, TArticleDetail } from 'shared/models';

const $RelatedShowAdditionalParams = atom<Record<string, unknown> & { rank: number }>({ rank: 0 });
const $CurrentArticle = atom({} as TArticleDetail);
const $CurrentAuthor = atom({} as IUserDetail);
const $CurrentComments = atom([] as IPrimaryComment[]);
const $BeforeHotKeywordsModule = atom(false);
const $BeforeGuessWordsCards = atom(false);
const $BeforeHashtagArticleCards = atom(false);

export const ImmersivePostItemAtoms = {
  $CurrentArticle,
  $CurrentAuthor,
  $CurrentComments,
  $RelatedShowAdditionalParams,
  $BeforeHotKeywordsModule,
  $BeforeGuessWordsCards,
  $BeforeHashtagArticleCards,
};
